import { useEffect, useState } from "react";
import { Main, Content } from "../../components/Layout";
import { Row, Col } from "react-bootstrap";
import useWrapper from "../../hooks/useWrapper";
import styles from "./styles.module.css";

export default function Changelog() {
  const { setbreadcrumb } = useWrapper();
  const [versions, setversions] = useState([]);
  const [isLoading, setisLoading] = useState(true);

  useEffect(() => {
    setbreadcrumb([{ label: "Changelog" }]);
  }, [setbreadcrumb]);

  useEffect(() => {
    (async () => {
      try {
        const _response = await fetch("/changelogs/manifest.json");
        const _versions = await _response.json();
        setversions(_versions || []);
      } catch (__error) {
        console.log("__error", __error);
        setversions([]);
      } finally {
        setisLoading(false);
      }
    })();
  }, []);

  return (
    <Main>
      <Content>
        <Row>
          <Col>
            <h2 className="mini-title">Changelog:</h2>
            <p className="small-label mb-3">Apresentações das novidades de cada versão do sistema.</p>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col>
            {!isLoading && versions.length === 0 && (
              <p className="small-label">Nenhuma apresentação disponível ainda.</p>
            )}
            <div className={styles.list}>
              {versions.map(__version => (
                <a
                  key={__version.version}
                  href={__version.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.item}
                >
                  <div className={styles.itemMain}>
                    <span className={styles.itemTitle}>{__version.title || `Versão ${__version.version}`}</span>
                    {!!__version.subtitle && <span className={styles.itemSubtitle}>{__version.subtitle}</span>}
                  </div>
                  <span className={styles.itemDate}>{__version.date}</span>
                </a>
              ))}
            </div>
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
